// extracted by css-extract-rspack-plugin
export default {"Box":"shared-issue-viewer-module__Box__R6fJqwa","Box_1":"shared-issue-viewer-module__Box_1__lXDqLF9"};